<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 17.677 18.426"
    aria-hidden="true"
  >
    <path
      id="Path_66"
      data-name="Path 66"
      d="M34.794,16a8.589,8.589,0,0,0-6.906,13.693L25.7,34.426l.572-.265,4.407-2.035A8.587,8.587,0,1,0,34.794,16Zm4.58,12.253A1.7,1.7,0,0,1,37.5,29.585a5.767,5.767,0,0,1-2.273-.768,9.483,9.483,0,0,1-2.695-2.276A9.29,9.29,0,0,1,30.9,23.447a5.82,5.82,0,0,1-.276-2.38,1.711,1.711,0,0,1,.3-.829,1.683,1.683,0,0,1,.679-.564,1.666,1.666,0,0,1,.714-.157,1.855,1.855,0,0,1,1.059.2,1.844,1.844,0,0,1,.645,1.5c0,.05,0,.1-.008.154a1.531,1.531,0,0,1-.226.81,2.006,2.006,0,0,1-.756.583,5.052,5.052,0,0,0,1.079,2.526,3.723,3.723,0,0,0,.879.848,6.946,6.946,0,0,0,1.355.729,2.01,2.01,0,0,1,.729-.618,1.539,1.539,0,0,1,.837-.05c.05.008.1.015.154.027a1.848,1.848,0,0,1,1.332.944A1.879,1.879,0,0,1,39.374,28.253Z"
      transform="translate(-25.7 -16)"
      fill="currentColor"
    />
  </svg>
</template>
